import { useState, useEffect } from 'react';
import OCREnabledField from './OCREnabledField';
import { validateScacCode } from '../../../util/ValidationUtils';

interface ScacCodeInputProps {
    scacCode: string;
    setScacCode: (scacCode: string) => void;
    handleChange: (e:any) => void;
    correlationId: string;
    isEnabled: boolean;
}

const ScacCodeInput = (props: ScacCodeInputProps) => {
    const {scacCode, setScacCode, handleChange, correlationId, isEnabled} = props;

    const [error, setError] = useState<string>();

    useEffect(() => {
        const invalidScacError = 'SCAC code must be alphanumeric and be 2 to 4 characters long.';

        if(scacCode && !validateScacCode(scacCode)) {
            setError(invalidScacError)
        } else {
            setError('')
        }
    }, [scacCode])

    return <OCREnabledField
                name="scacCode"
                label="SCAC CODE"
                value={scacCode}
                onChange={handleChange}
                setText={setScacCode}
                placeholder="Enter the SCAC code"
                isEnabled={isEnabled}
                correlationId={correlationId}
                error={error}
            />
}

export default ScacCodeInput;